import easelAPI, {
  EaselResponse,
  EaselPayloadResponse,
  getOptions,
  postOptions,
  putOptions,
} from 'apis/helpers/easelAPI'
import galleryAPI, {
  GalleryResponse,
  postOptions as galleryPostOptions,
} from 'apis/helpers/galleryAPI'
import { CuratorNotes } from 'types/CuratorNotes'
import { MeasurementUnit } from 'types/User/Session'

export const fetchMyUser = async (): Promise<Record<string, any>> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchMyUser',
    options,
    url: `/myself`,
  })
  return json
}

export const updateMyVacationStatus = async (status: boolean): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      onVacation: status,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'updateMyVacationStatus',
    options,
    url: `/my-vacation-status`,
  })
  return json
}

export const updateMyCheckInStatus = async (): Promise<EaselResponse> => {
  const options = postOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'updateMyCheckInStatus',
    options,
    url: `/my-checkin-status`,
  })
  return json
}

export const updateUserMeasurementUnit = async (
  measurementUnit: MeasurementUnit
): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify(measurementUnit),
  }
  const json = await easelAPI.fetchJSON({
    name: 'updateUserMeasurementUnit',
    options,
    url: '/my-preferred-measurement',
  })
  return json
}

export const fetchMyCuratorNotes = async (): Promise<EaselPayloadResponse<CuratorNotes>> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchMyCuratorNotes',
    options,
    url: '/myself',
  })
  const payload = json.payload || { curatorNotesAnswers: null }
  return {
    ...json,
    payload: payload.curatorNotesAnswers,
  }
}

// Should this be in a TRY catch
export const putMyCuratorNotes = async (
  payload: CuratorNotes
): Promise<EaselPayloadResponse<CuratorNotes>> => {
  const options = {
    ...putOptions,
    body: JSON.stringify(payload),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'putMyCuratorNotes',
    options,
    url: '/my-curator-notes',
  })
  return json
}

export const fetchMyProfile = async (): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchMyProfile',
    options,
    url: '/my-profile',
  })
  return json
}

export const putMyProfile = async (data: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...putOptions,
    body: JSON.stringify(data),
  }
  const response = await easelAPI.fetchResponse({
    options,
    url: '/my-profile',
  })

  const json = await easelAPI.parseResponseToValidateLoginJSON(response, 'putMyProfile')

  if (response.status === 400) {
    if (json.message) {
      return {
        success: false,
        payload: {
          errorMessage: json.message,
        },
      }
    }
  }

  return json
}

export const fetchMyAccount = async (): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchMyAccount',
    options,
    url: '/my-account',
  })
  return json
}

export const putMyAccount = async (data: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...putOptions,
    body: JSON.stringify(data),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'putMyAccount',
    options,
    url: '/my-account',
  })

  if (!json.success) {
    return {
      success: false,
      payload: {
        errorMessage: json.message || 'failed to update account',
      },
    }
  }
  return json
}

type ConvertCollectorAccountToArtistAccountProps = {
  captchaAction: string
  captchaToken: string
}

export const postConvertCollectorAccountToArtistAccount = async (
  data: ConvertCollectorAccountToArtistAccountProps
): Promise<GalleryResponse> => {
  const options = {
    ...galleryPostOptions,
    body: JSON.stringify({
      captcha_action: data.captchaAction,
      captcha_token: data.captchaToken,
    }),
  }
  const response = await galleryAPI.fetchResponse({
    options,
    url: `/user/convert-collector-to-artist-account`,
  })

  if (response.status === 200) {
    return {
      success: true,
    }
  }
  const json = await galleryAPI.parseResponseToJSON(
    response,
    'postConvertCollectorAccountToArtistAccount'
  )
  return json
}
